<template>
  <div>
    <div class="page-header header-filter bg-3">
      <b-container>
        <b-row>
          <b-col>
            <h1>Your Account: {{ playerName }}</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <h3>Strava Connection</h3>
          </b-col>
        </b-row>
        <b-row v-if="isStravaConnected" align-v="center">
          <b-col cols="9">Your Velios account is connected to Strava</b-col>
          <b-col><b-button variant="primary">Disconnect</b-button></b-col>
        </b-row>
        <b-row v-else align-v="center">
          <b-col cols="7">Upload your Velios workouts to Strava</b-col>
          <b-col cols="5"><b-button variant="primary" @click="startStravaAuth()">Connect</b-button></b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { BButton } from "bootstrap-vue"

const { mapState } = createNamespacedHelpers("session");

export default {
  name: "PlayerSettings",
  components: {
    BButton
  },
  async created() {
  },
  computed: {
    ...mapState({
      player: "player",
      playerName() {
        return this.player && this.player.name;
      },
      isStravaConnected() {
        return this.player?.restricted?.stravaRefreshToken?.length > 0;
      },
    }),
  },
  methods: {
    startStravaAuth() {
      let uri = window.location.href;
      uri = uri.substring(0, uri.indexOf("/", 10)) + "/strava-auth";
      uri = encodeURI(uri);
      const req = `http://www.strava.com/oauth/authorize?client_id=62596&response_type=code&redirect_uri=${uri}&approval_prompt=force&scope=read,activity:write`;
      console.log(req)
      window.location.href = req;
    },
  },
  destroyed() {
  },
};
</script>

<style scoped>
.page-header {
  height: auto;
  padding-top: 100px;
  padding-bottom: 50px;
}
</style>